<template>
<!-- eslint-disable -->
      <Job-Detail></Job-Detail>
</template>

<script>
  import JobDetail from './components/JobDetail.vue'
  export default {
    name: 'App',
    components: {
      JobDetail
    }
  }
</script>

<style>
    @font-face {
			font-family: "averta-regular";
			src: url("./assets/fonts/AvertaDemo-Regular.otf");
			src: url("./assets/fonts/AvertaDemo-Regular.otf") format("woff"),
			url("./assets/fonts/AvertaDemo-Regular.otf") format("opentype"),
			url("./assets/fonts/AvertaDemo-Regular.otf") format("svg"); 
		}
    @font-face {
			font-family: "averta-light";
			src: url("./assets/fonts/averta_light.woff");
			src: url("./assets/fonts/averta_light.woff") format("woff"),
			url("./assets/fonts/averta_light.woff") format("opentype"),
			url("./assets/fonts/averta_light.woff") format("svg");
		}
		@font-face {
			font-family: "averta-extrabold";
			src: url("./assets/fonts/averta_extrabold.woff");
			src: url("./assets/fonts/averta_extrabold.woff") format("woff"),
			url("./assets/fonts/averta_extrabold.woff") format("opentype"),
			url("./assets/fonts/averta_extrabold.woff") format("svg");
		} 
    @font-face {
			font-family: "averta-semibold";
			src: url("./assets/fonts/averta_semibold.woff");
			src: url("./assets/fonts/averta_semibold.woff") format("woff"),
			url("./assets/fonts/averta_semibold.woff") format("opentype"),
			url("./assets/fonts/averta_semibold.woff") format("svg");
		} 
    #app {
      font-family:  "averta-regular";
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;

    }
    
    p{
      font-family: 'averta-regular' !important;
    }
    
    a {
      color: #e73246;
      text-decoration: none;
    }
    a.black {
        color: #000;
        text-decoration: none;
    }
    nav {
      background-color: #69c350;
      color: #ffffff;
    }
    nav a{
      color: #ffffff;
    }

    nav a.router-link-exact-active {
      color: #000000;
    } 

    h1 {
      font-family: 'averta-regular';
      /* font-family: 'Averta'; */
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 56px;
    }

    h2 { /*h3*/
      font-family: 'averta-extrabold' !important;
      font-style: normal;
      font-weight: 800;
      font-size: 32px;
      line-height: 32px;
    }

    h4 {
      font-family: 'averta-extrabold', Arial, sans-serif !important;
      font-style: normal;
      font-weight: 800;
      font-size: 24px;
      line-height: 28px;
    }

    p{
      font-family: 'averta-regular';
      /* font-family: 'Averta'; */
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }

    .p--bold{
      font-family: 'averta-regular';
      /* font-family: 'Averta'; */
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }


    .light{
        /* font-family: 'Averta' !important; */
        font-family: 'averta-light' !important;
        font-style: normal !important;
        font-weight: 300 !important;
        font-size: 16px !important;
        line-height: 24px !important;
    }

    .subline{
        /* font-family: 'Averta' !important; */
        font-family: 'averta-light' !important;
        font-style: normal !important;
        font-weight: 300 !important;
        font-size: 24px !important;
        line-height: 32px !important;
    }


    .bg--lightgray{
     background-color: #F6F6F6; 
    }

    .btn{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 2px 24px;
      /* padding: 10px 24px; */
      gap: 8px;
      background: #E73246;
      color: #ffffff !important;
      border: 2px solid #E73246;
      text-decoration: none;
    }

  .btn--ghost{
      background-color: #ffffff;;
      color: #000000 !important;
      border: 1px solid #000000;
      padding: 15px 30px;
      line-height: 24px;
      font-size: 14px;
  }

  #page-container{
    padding-top: 0px !important;
  }

  #main-content .container {
    padding-top: 18px !important;
  }
  #spanreq:has(.OutlineElement), #spanben:has(.OutlineElement){
    display: none;
  }
</style>
